class Timer
{

    constructor() {
        this._startTime = this.getAbsTime();

    }

    getAbsTime()
    {
        return (new Date()).getTime() / 1000;
    }

    getStartAbsTime()
    {
        return this._startTime;
    }

    getTime()
    {
        return this.getAbsTime() - this._startTime;
    }

}

export default Timer;